import * as OV from "online-3d-viewer";

OV.SetExternalLibLocation("libs"); // tell the engine where to find the libs folder
OV.Init3DViewerElements(); // init all viewers on the page

// // OV.StartEmbed("libs");
// window.OV = OV;

// window.addEventListener("load", () => {
//   // get the parent element of the viewer
//   let parentDiv = document.getElementById("viewer");
//   d;

//   window.OV = OV;
//   // initialize the viewer with the parent element and some parameters
//   let viewer = new OV.EmbeddedViewer(parentDiv, {
//     // eye, center, up, fov
//     // camera: new OV.Camera(new OV.Coord3D(1.5, 3.0, 2.0), new OV.Coord3D(0.0, 0.0, 0.0), new OV.Coord3D(0.0, 0.0, 1.0), 45),
//     // camera: { x: -2.550644319738012, y: 0.3582416415479011, z: -0.11450646494064383 },
//     // camera: new OV.Camera(new OV.Coord3D(-2.550644319738012, 0.3582416415479011, -0.11450646494064383)),
//     backgroundColor: new OV.RGBAColor(103, 235, 52, 255),
//     defaultColor: new OV.RGBColor(0, 23, 207),
//     edgeSettings: {
//       showEdges: true,
//       edgeColor: new OV.RGBColor(176, 23, 207),
//       edgeThreshold: 1,
//     },
//     environmentSettings: {
//       environmentMap: [
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/negx.jpg",
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/negy.jpg",
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/negz.jpg",
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/posx.jpg",
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/posy.jpg",
//         "http://127.0.0.1:5501/assets/envmaps/fishermans_bastion/posz.jpg",
//       ],
//       backgroundIsEnvMap: false,
//     },
//     onModelLoaded: () => {
//       let model = viewer.GetModel();
//       console.log({ model });
//       window.viewer = viewer;
//       // do something with the model
//     },
//   });

//   // load a model providing model urls
//   viewer.LoadModelFromUrlList(["https://modelviewer.dev/assets/ShopifyModels/Chair.glb"]);
// });
